"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mint = exports.getMintInstructionDataSerializer = void 0;
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const hooked_1 = require("../../hooked");
const shared_1 = require("../shared");
function getMintInstructionDataSerializer() {
    return (0, serializers_1.mapSerializer)((0, serializers_1.struct)([
        ['discriminator', (0, serializers_1.array)((0, serializers_1.u8)(), { size: 8 })],
        ['mintArgs', (0, serializers_1.bytes)({ size: (0, serializers_1.u32)() })],
        ['group', (0, serializers_1.option)((0, serializers_1.string)())],
    ], { description: 'MintInstructionData' }), (value) => ({
        ...value,
        discriminator: [51, 57, 225, 47, 182, 146, 137, 166],
    }));
}
exports.getMintInstructionDataSerializer = getMintInstructionDataSerializer;
// Instruction.
function mint(context, input) {
    // Program ID.
    const programId = context.programs.getPublicKey('mplCandyGuard', 'Guard1JwRhJkVH6XZhzoYxeBVQe872VH6QggF4BWmS9g');
    // Accounts.
    const resolvedAccounts = {
        candyGuard: {
            index: 0,
            isWritable: false,
            value: input.candyGuard ?? null,
        },
        candyMachineProgram: {
            index: 1,
            isWritable: false,
            value: input.candyMachineProgram ?? null,
        },
        candyMachine: {
            index: 2,
            isWritable: true,
            value: input.candyMachine ?? null,
        },
        candyMachineAuthorityPda: {
            index: 3,
            isWritable: true,
            value: input.candyMachineAuthorityPda ?? null,
        },
        payer: { index: 4, isWritable: true, value: input.payer ?? null },
        nftMetadata: {
            index: 5,
            isWritable: true,
            value: input.nftMetadata ?? null,
        },
        nftMint: { index: 6, isWritable: true, value: input.nftMint ?? null },
        nftMintAuthority: {
            index: 7,
            isWritable: false,
            value: input.nftMintAuthority ?? null,
        },
        nftMasterEdition: {
            index: 8,
            isWritable: true,
            value: input.nftMasterEdition ?? null,
        },
        collectionAuthorityRecord: {
            index: 9,
            isWritable: false,
            value: input.collectionAuthorityRecord ?? null,
        },
        collectionMint: {
            index: 10,
            isWritable: false,
            value: input.collectionMint ?? null,
        },
        collectionMetadata: {
            index: 11,
            isWritable: true,
            value: input.collectionMetadata ?? null,
        },
        collectionMasterEdition: {
            index: 12,
            isWritable: false,
            value: input.collectionMasterEdition ?? null,
        },
        collectionUpdateAuthority: {
            index: 13,
            isWritable: false,
            value: input.collectionUpdateAuthority ?? null,
        },
        tokenMetadataProgram: {
            index: 14,
            isWritable: false,
            value: input.tokenMetadataProgram ?? null,
        },
        tokenProgram: {
            index: 15,
            isWritable: false,
            value: input.tokenProgram ?? null,
        },
        systemProgram: {
            index: 16,
            isWritable: false,
            value: input.systemProgram ?? null,
        },
        recentSlothashes: {
            index: 17,
            isWritable: false,
            value: input.recentSlothashes ?? null,
        },
        instructionSysvarAccount: {
            index: 18,
            isWritable: false,
            value: input.instructionSysvarAccount ?? null,
        },
    };
    // Arguments.
    const resolvedArgs = { ...input };
    // Default values.
    if (!resolvedAccounts.candyGuard.value) {
        resolvedAccounts.candyGuard.value = (0, hooked_1.findCandyGuardPda)(context, {
            base: (0, shared_1.expectPublicKey)(resolvedAccounts.candyMachine.value),
        });
    }
    if (!resolvedAccounts.candyMachineProgram.value) {
        resolvedAccounts.candyMachineProgram.value = context.programs.getPublicKey('mplCandyMachine', 'CndyV3LdqHUfDLmE5naZjVN8rBZz4tqhdefbAnjHG3JR');
        resolvedAccounts.candyMachineProgram.isWritable = false;
    }
    if (!resolvedAccounts.candyMachineAuthorityPda.value) {
        resolvedAccounts.candyMachineAuthorityPda.value =
            (0, hooked_1.findCandyMachineAuthorityPda)(context, {
                candyMachine: (0, shared_1.expectPublicKey)(resolvedAccounts.candyMachine.value),
            });
    }
    if (!resolvedAccounts.payer.value) {
        resolvedAccounts.payer.value = context.payer;
    }
    if (!resolvedAccounts.nftMetadata.value) {
        resolvedAccounts.nftMetadata.value = (0, mpl_token_metadata_1.findMetadataPda)(context, {
            mint: (0, shared_1.expectPublicKey)(resolvedAccounts.nftMint.value),
        });
    }
    if (!resolvedAccounts.nftMintAuthority.value) {
        resolvedAccounts.nftMintAuthority.value = context.identity;
    }
    if (!resolvedAccounts.nftMasterEdition.value) {
        resolvedAccounts.nftMasterEdition.value = (0, mpl_token_metadata_1.findMasterEditionPda)(context, {
            mint: (0, shared_1.expectPublicKey)(resolvedAccounts.nftMint.value),
        });
    }
    if (!resolvedAccounts.collectionAuthorityRecord.value) {
        resolvedAccounts.collectionAuthorityRecord.value =
            (0, mpl_token_metadata_1.findCollectionAuthorityRecordPda)(context, {
                mint: (0, shared_1.expectPublicKey)(resolvedAccounts.collectionMint.value),
                collectionAuthority: (0, shared_1.expectPublicKey)(resolvedAccounts.candyMachineAuthorityPda.value),
            });
    }
    if (!resolvedAccounts.collectionMetadata.value) {
        resolvedAccounts.collectionMetadata.value = (0, mpl_token_metadata_1.findMetadataPda)(context, {
            mint: (0, shared_1.expectPublicKey)(resolvedAccounts.collectionMint.value),
        });
    }
    if (!resolvedAccounts.collectionMasterEdition.value) {
        resolvedAccounts.collectionMasterEdition.value = (0, mpl_token_metadata_1.findMasterEditionPda)(context, { mint: (0, shared_1.expectPublicKey)(resolvedAccounts.collectionMint.value) });
    }
    if (!resolvedAccounts.tokenMetadataProgram.value) {
        resolvedAccounts.tokenMetadataProgram.value = context.programs.getPublicKey('mplTokenMetadata', 'metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s');
        resolvedAccounts.tokenMetadataProgram.isWritable = false;
    }
    if (!resolvedAccounts.tokenProgram.value) {
        resolvedAccounts.tokenProgram.value = context.programs.getPublicKey('splToken', 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');
        resolvedAccounts.tokenProgram.isWritable = false;
    }
    if (!resolvedAccounts.systemProgram.value) {
        resolvedAccounts.systemProgram.value = context.programs.getPublicKey('splSystem', '11111111111111111111111111111111');
        resolvedAccounts.systemProgram.isWritable = false;
    }
    if (!resolvedAccounts.recentSlothashes.value) {
        resolvedAccounts.recentSlothashes.value = (0, umi_1.publicKey)('SysvarS1otHashes111111111111111111111111111');
    }
    if (!resolvedAccounts.instructionSysvarAccount.value) {
        resolvedAccounts.instructionSysvarAccount.value = (0, umi_1.publicKey)('Sysvar1nstructions1111111111111111111111111');
    }
    // Accounts in order.
    const orderedAccounts = Object.values(resolvedAccounts).sort((a, b) => a.index - b.index);
    // Keys and Signers.
    const [keys, signers] = (0, shared_1.getAccountMetasAndSigners)(orderedAccounts, 'programId', programId);
    // Data.
    const data = getMintInstructionDataSerializer().serialize(resolvedArgs);
    // Bytes Created On Chain.
    const bytesCreatedOnChain = 0;
    return (0, umi_1.transactionBuilder)([
        { instruction: { keys, programId, data }, signers, bytesCreatedOnChain },
    ]);
}
exports.mint = mint;
//# sourceMappingURL=mint.js.map